import BaseBlock from "./BaseBlock";
import Swiper, {Autoplay, Navigation, Pagination} from "swiper";

export default class Testimonials extends BaseBlock {

	init() {

		const sliderEl = this.block.querySelector(".swiper");

		if (sliderEl) {
			new Swiper(sliderEl, {
				loop: true,
				spaceBetween: 40,
				autoplay: {
					delay: 5000,
					disableOnInteraction: false
				},
				navigation: {
					prevEl: this.block.querySelector(".swiper-button-prev"),
					nextEl: this.block.querySelector(".swiper-button-next")
				},
				pagination: {
					el: this.block.querySelector(".swiper-pagination"),
					clickable: true
				},
				modules: [Autoplay, Navigation, Pagination]
			});
		}

	}
}
